import styled from 'styled-components';
import { Col } from 'antd';

export default styled(Col)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
  border-right: 1px solid #e8e8e8;
`;
